// features/Resume/resumeApiSlice.js
import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';
import axios from 'axios';
import { setResumeDownloadProgress } from './resumeSlice';

export const resumeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResumeByEmployee: builder.query({
      query: (empCode) => `${ENDPOINTS.RESUME.BY_EMPLOYEE}${empCode}`,
      providesTags: (result, error, empCode) => [{ type: 'Resume', id: empCode }],
    }),
    getProfileStrengthByEmployee: builder.query({
      query: (empCode) => `${ENDPOINTS.RESUME.PROFILE_STRENGTH}${empCode}`,
      providesTags: (result, error, empCode) => [{ type: 'Resume', id: empCode }],
    }),
    exportResume: builder.mutation({
      query: ({ empCode, businessUnit, format }) => ({
        url: `${ENDPOINTS.RESUME.EXPORT}${empCode}`,
        method: 'POST',
        body: { format, businessUnit, host: process.env.REACT_APP_HOST_URL },
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const contentDisposition = response.headers.get('content-disposition');
          const filename =
            contentDisposition?.split('filename=')[1]?.split(';')[0]?.replace(/"/g, '') ||
            `Resume_${empCode}.${format}`;
          const blob = await response.blob();

          return { blob, filename };
        },
      }),
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        console.log('download started');
        dispatch(setResumeDownloadProgress({ downloadStarted: true }));

        try {
          const { data } = await queryFulfilled;
          dispatch(setResumeDownloadProgress({ downloadStarted: false }));
        } catch (err) {
          dispatch(setResumeDownloadProgress({ downloadStarted: false }));
        } finally {
          console.log('download completed');
        }
      },
      invalidatesTags: [{ type: 'Resume', id: 'LIST' }],
    }),
  }),
});

export const { useGetResumeByEmployeeQuery, useExportResumeMutation, useGetProfileStrengthByEmployeeQuery } =
  resumeApiSlice;
